import { useState } from 'react'
import clsx from 'clsx'
import RoomScansTab from '../features/assets/RoomScansTab.jsx'

const TABS = [
  { id: 'room-scans', label: 'Room Scans' },
  { id: 'floor-plans', label: 'Floor Plans' },
  { id: 'models', label: '3D Models' },
]

export default function AssetsPage() {
  const [active, setActive] = useState('room-scans')

  return (
    <main className="app-content">
      <header className="page-header">
        <div>
          <h1 className="page-header__title">Assets</h1>
          <div className="page-header__sub">
            Room scans, floor plans, and 3D models uploaded across the platform.
          </div>
        </div>
      </header>

      <nav className="assets-tabs" aria-label="Asset categories">
        {TABS.map((tab) => (
          <button
            key={tab.id}
            type="button"
            className={clsx('assets-tab', active === tab.id && 'is-active')}
            onClick={() => setActive(tab.id)}
            aria-pressed={active === tab.id}
          >
            {tab.label}
          </button>
        ))}
      </nav>

      <section className="assets-tab-panel">
        {active === 'room-scans' && <RoomScansTab />}
        {active === 'floor-plans' && (
          <div className="card card--lg muted">
            Floor plans library is coming online next. For now, floor-plan PNGs uploaded via the floor workspace live with each floor.
          </div>
        )}
        {active === 'models' && (
          <div className="card card--lg muted">
            FBX and GLB models will surface here. Today they live inside the floor workspace.
          </div>
        )}
      </section>
    </main>
  )
}
